import BaseComponent from '../base-component/base-component'
import { checkEnterKey } from '../../utils/utils'
import Cart from './cart'

class CartRemoveButton extends BaseComponent {
  connectedCallback(): void {
    this.addEventListener('keydown', this.handleKeyDown)
    this.addEventListener('click', this.handleButtonClick)
  }

  disconnectedCallback(): void {
    this.removeEventListener('keydown', this.handleKeyDown)
    this.removeEventListener('click', this.handleButtonClick)
  }

  handleButtonClick = (): void => {
    this.update()
  }

  update(): void {
    const cart = this.closest<Cart>('cart-page, cart-drawer')
    const cartItemIndex = this.dataset.index

    if (cart && cartItemIndex) {
      cart.updateItem(+cartItemIndex, 0)
    }
  }

  handleKeyDown = (event: KeyboardEvent): void => {
    const isEnterKey = checkEnterKey(event.key || event.keyCode)

    if (isEnterKey) {
      event.preventDefault()

      this.update()
    }
  }
}

export default CartRemoveButton
